import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  getGlobalSearchData,
  updateConfig,
} from "../../../../store/slices/Global";

import useObserver from "../../../../utils/hooks/useObserver";
import { enquiries } from "../../../../store/queries/enquiries";
import { settings } from "../../../../store/queries/settings";
import { type } from "../../../../store/queries/type";
import { markNotificationRead } from "./api";
import { colors } from "../../../../store/queries/colors";
import { orders } from "../../../../store/queries/orders";
import { nonSeasonalOffers } from "../../../../store/queries/nonSeasonalOffers";
import { useGetNotificationListDataQuery, useUpdateNotificationDataMutation } from "../../../../store/queries/notifications";

const useHeaderActions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const activeUser = useMemo(
    () => localStorage.getItem("USER_DETAILS") ?? [],
    []
  );

  const [page, setPage] = useState(1);

  const [isProfileViewVisible, setProfileViewVisible] = useState(false);
  const searchInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const globalState = useSelector((state) => state.global);
  const subAdminState = useSelector((state) => state.subAdmins);
  const notificationState = useSelector((state) => state.notification);
  const [updateNotification] = useUpdateNotificationDataMutation();

  const {
    data: notification = {},
    isFetching,
    // isLoading,
    refetch,
  } = useGetNotificationListDataQuery({
    per_page: notificationState.currentPageSize,
    page: notificationState.currentPage,
  });
  
  useEffect(() => {
    
    let notificationData = notification?.data?.result?.filter(
      (item) => item.read_at === null
    );
    if (notificationData?.length > 0) {
      dispatch(
        updateConfig((state) => {
          state.isNewNotification = true;
        })
      );
      // setIsNewNotification(true);
    }
  }, [notification?.data]);

  useEffect(() => {
    if (isProfileViewVisible)
    dispatch(
      updateConfig((state) => {
        state.isProfileViewVisible = false;
        setProfileViewVisible(false);
      })
    );
  }, [isProfileViewVisible]);

  const handleReadNotification = (isNewNotification) => {
    if (isNewNotification) markNotificationRead().then((response) => {});
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "k") {
        event.preventDefault();
        setIsModalOpen((state) => !state);
        focusSearchInput();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [searchInputRef]);

  const focusSearchInput = () => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
    dispatch(
      updateConfig((state) => {
        state.searchKey = "";
        state.searchData = {};
      })
    );
  };

  const handleViewProfile = () => {
    dispatch(
      updateConfig((state) => {
        state.isProfileViewVisible = true;
      })
    );
  };

  const handleCloseProfileView = () => {
    dispatch(
      updateConfig((state) => {
        state.isProfileViewVisible = false;
      })
    );
  };

  const handleLogout = () => {
    dispatch(enquiries.util.resetApiState());
    dispatch(type.util.resetApiState());
    dispatch(orders.util.resetApiState());
    dispatch(nonSeasonalOffers.util.resetApiState());
    dispatch(colors.util.resetApiState());
    dispatch(settings.util.resetApiState());

    localStorage.removeItem("USER_DETAILS");
    localStorage.removeItem("USER_ACCESS_TOKEN");
    localStorage.removeItem("dashboard_permissions");

    navigate("/");
  };

  const handleSettings = () => {
    navigate("/settings/appearance");
  };

  const handleProfileRedirect = (userId) => {
    const ids = params.get("id")
      ? [...params.get("id").split(","), userId]
      : [userId];

    const newIds = ids.filter((id) => id !== userId).join(",");

    window.open(
      `${window.location.origin}/${`profile?active=${userId}&id=${newIds}`}`
    );
  };

  const handleNotificationRedirect = () => {
    navigate("/notifications");

    setTimeout(() => {
      updateNotification().then((response) => {
        if (response?.data?.status_code === 200) {
          dispatch(
            updateConfig((state) => {
              state.isNewNotification = false;
            })
          );
        }
      });
    }, 1000);
  };

  return {
    isModalOpen,
    searchInputRef,
    globalState,
    subAdminState,
    userData: globalState?.searchData?.[activeUser],
    setIsModalOpen,
    closeModal,
    handleLogout,
    handleProfileRedirect,
    handleSettings,
    handleViewProfile,
    handleCloseProfileView,
    setProfileViewVisible,
    handleReadNotification,
    handleNotificationRedirect,
    notification: notification,
    isNewNotification: globalState.isNewNotification,
    refetch
  };
};

export default useHeaderActions;
